import React, { useState } from "react";

import { MailOutlined } from "@ant-design/icons";
import { Alert, Button, Form, Input, Modal } from "antd";
import { toast } from "utils/toast";

interface EmailVerificationModalProps {
  open: boolean;
  onCancel: () => void;
  onEmailVerified: (email: string) => void;
  loading?: boolean;
}

const EmailVerificationModal: React.FC<EmailVerificationModalProps> = ({
  open,
  onCancel,
  onEmailVerified,
  loading = false,
}) => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: { email: string }) => {
    try {
      setIsSubmitting(true);
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(values.email)) {
        toast.error("Por favor ingresa un correo electrónico válido");
        return;
      }

      onEmailVerified(values.email);
      form.resetFields();
    } catch (error) {
      console.error("Email verification error:", error);
      toast.error("Error al verificar el correo electrónico");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      title="Verificación de Acceso"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={600}
      centered
    >
      <Alert
        description="Para acceder a este reporte, por favor ingresa tu correo electrónico."
        type="info"
        showIcon
        style={{ marginBottom: 20 }}
      />

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          name="email"
          label="Correo electrónico"
          rules={[
            {
              required: true,
              message: "Por favor ingresa tu correo electrónico",
            },
            { type: "email", message: "Por favor ingresa un correo válido" },
          ]}
        >
          <Input
            prefix={<MailOutlined />}
            placeholder="correo@ejemplo.com"
            size="large"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={isSubmitting || loading}
            block
            size="large"
          >
            {loading ? "Verificando..." : "Acceder al Reporte"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EmailVerificationModal;
